import {ProgressBar} from '@jobseeker/lotus/components';
import {Box, Card, CardContent} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {AwardType} from '../type';
import {TrackEventUBA} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import {useInView} from '@jobseeker/lotus/hooks';
import {AppState, JobDetail} from '@jobseeker/common-core/types';
import {useSelector} from 'react-redux';

type AwardsSectionProps = {
  awards?: AwardType[];
  templateInfo?: {
    templateNo?: string;
    origin?: string;
  };
};
const CompanyAwards: React.FC<AwardsSectionProps> = ({
  awards,
  templateInfo,
}) => {
  const router = useRouter();
  const jobInfo: JobDetail = useSelector((state: AppState) => state.jobDetail);
  const {ref, isInView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });
  const [companyAwardsTracked, setCompanyAwardsTracked] = useState(false);

  useEffect(() => {
    if (isInView && !companyAwardsTracked) {
      TrackEventUBA('sectionView', 'view', {
        ref: router.query.ref || '',
        pageName: 'JD',
        jobID: jobInfo.id,
        page: 'JD',
        templateID: templateInfo?.templateNo,
        isBranded: 'Yes',
        companyID: jobInfo?.companyData?.companyId,
        centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
        companyName: jobInfo?.companyData?.companyName,
        section: 'Awards',
        sessionUsername: sessionStorage.getItem('userId') || '',
      });
      setCompanyAwardsTracked(true);
    }
  }, [isInView, companyAwardsTracked]);

  return (
    <Box p={2} pl={1.5} ref={ref}>
      <Card
        variant="outlined"
        sx={{
          border: 'none',
          backgroundColor: '#F9FAFB',
        }}
      >
        <CardContent
          sx={{
            padding: 0,
            '&:last-child': {
              pb: 0,
            },
          }}
        >
          {awards ? (
            <ProgressBar
              steps={awards?.map((award, index) => ({
                label: `${award.awardsYear}`,
                description: award.awardsDescription || '',
                active: index === 0,
                link: '',
              }))}
              showStepCounter={false}
              lockFutureSteps={false}
              useDotsOnly={true}
              dividerColor="#C4C7D8"
            />
          ) : (
            <></>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default CompanyAwards;
